import { FormControl, FormHelperText, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import { FC } from "react";
import { RegisterOptions, useController } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: "200px",
    margin: "8px 0",
    "& label": {
      zIndex: 1,
      padding: theme.spacing(0, 0.5),
      transform: "translate(10px, 12px) scale(1)",
      pointerEvents: "none",
      backgroundColor: "#fafafa",
    },
  },
}));

const CustomSelectField: FC<CustomSelectFieldProps> = ({
  listItems,
  label,
  multiple,
  defaultValue,
  disabled = false,
  ...rest
}) => {
  const classes = useStyles({});

  const {
    field,
    fieldState: { invalid, isTouched, error },
  } = useController(rest);

  return (
    <FormControl error={isTouched && invalid} variant="outlined" size="small" className={classes.root}>
      <InputLabel id={label}>{label}</InputLabel>
      <Select {...field} labelId={label} fullWidth multiple={multiple} defaultValue={defaultValue} disabled={disabled}>
        {listItems.map((entry: any) => (
          <MenuItem key={entry.id} value={entry.id}>
            {entry.name}
          </MenuItem>
        ))}
      </Select>
      {isTouched && invalid && <FormHelperText>{error?.message}</FormHelperText>}
    </FormControl>
  );
};

interface CustomSelectFieldProps {
  control: any;
  name: string;
  label: string;
  listItems: any[];
  multiple?: boolean;
  rules?: RegisterOptions;
  defaultValue: string | string[];
  disabled?: boolean;
}

export default CustomSelectField;
